var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9987 1.3335C4.3227 1.3335 1.33203 4.32416 1.33203 8.00016C1.33203 11.6762 4.3227 14.6668 7.9987 14.6668C11.6747 14.6668 14.6654 11.6762 14.6654 8.00016C14.6654 4.32416 11.6747 1.3335 7.9987 1.3335ZM7.9987 13.3335C5.05803 13.3335 2.66536 10.9408 2.66536 8.00016C2.66536 5.0595 5.05803 2.66683 7.9987 2.66683C10.9394 2.66683 13.332 5.0595 13.332 8.00016C13.332 10.9408 10.9394 13.3335 7.9987 13.3335Z",
    fill: "#4E5D78"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66536 4.6665H7.33203V8.6665H11.332V7.33317H8.66536V4.6665Z",
    fill: "#4E5D78"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.85fb1719490362170586d8edee827cce.svg";
export { ForwardRef as ReactComponent };